module.exports = __webpack_public_path__ + "static/media/striped_bar_WPC_tall.c74db2d1.svg";